import * as React from "react";

// useSyncExternalStore hydrates with the server snapshot (false) and then re-renders
// with the real match. Reading window in a useState initializer skipped that re-render,
// so SSR'd pages kept the desktop markup on phones.
export function useMediaQuery(query: string): boolean {
  const subscribe = React.useCallback(
    (onChange: () => void) => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    },
    [query],
  );
  return React.useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}
